import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from 'app/services/app-state.service';
import { AuthService } from 'app/services/auth.service';
import { DeviceService } from 'app/services/device.service';
import { NavUserWidgetComponent } from '../nav-user-widget/nav-user-widget.component';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-nav-lite',
  standalone: true,
  imports: [CommonModule, NavUserWidgetComponent, SvgLoaderComponent],
  templateUrl: './nav-lite.component.html',
  styleUrl: './nav-lite.component.scss'
})
export class NavLiteComponent {
  isNavIOS: boolean = false;
  currentTheme: string = 'dark-theme';

  private bodyClassObserver: MutationObserver;

  constructor(private authService: AuthService, private router: Router, private deviceService: DeviceService, public appState: AppStateService) { }

  ngOnInit() {
    this.observeBodyClassChanges();
    const isAppleDevice = this.deviceService.isAppleDevice() || false;
    const deviceType = this.deviceService.getDeviceType() || 'desktop';
    if (isAppleDevice && deviceType === 'mobile') {
      this.isNavIOS = true;
    }
  }

  private observeBodyClassChanges(): void {
    const body = document.body;

    const updateTheme = () => {
      this.currentTheme = body.classList.contains('dark-theme') ? 'dark-theme' : 'light-theme';
    };

    this.bodyClassObserver = new MutationObserver(updateTheme);

    this.bodyClassObserver.observe(body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    updateTheme();
  }

  getLogoSize() {
    const deviceType = this.deviceService.getDeviceType();
    switch (deviceType) {
      case 'desktop':
        return '22px';
      case 'tablet':
        return '22px';
      case 'mobile':
        return '22px';
      default:
        return '22px';
    }
  }

  ngOnDestroy() {
    if (this.bodyClassObserver) {
      this.bodyClassObserver.disconnect();
    }
  }
}
